import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { detailBuildEmployer } from "../../actions/employerAction";
import RightDash from "../../components/RightDash";
import EmployerWelcome from "../../components/EmployerWelcome";
import EmployerMenu from "../../components/EmployerMenu";
import Message from "../../components/Message";
import Login from "../Login";
import Signout from "../../components/Signout";

const EmployerJob = ({ match, history, resizeMenu, setResizeMenu }) => {
  const id = match.params.id;

  const dispatch = useDispatch();

  const userLogin = useSelector((state) => state.userLogin);

  const { userInfo } = userLogin;

  const detailBuild = useSelector((state) => state.detailBuild);

  const { loading, job, error } = detailBuild;

  useEffect(() => {
    dispatch(detailBuildEmployer(id));
  }, [detailBuildEmployer]);

  if (!userInfo) {
    return <Login />;
  }

  if (userInfo && userInfo.role === "developer") {
    history.push("/developer/dashboard");
  }

  return (
    <div className="dashboard">
      <EmployerMenu resizeMenu={resizeMenu} setResizeMenu={setResizeMenu} />
      <RightDash resizeMenu={resizeMenu} setResizeMenu={setResizeMenu}>
        <div className="right-wrapper">
          <EmployerWelcome />
          <div className="main p-3">
            {loading ? (
              <div className="spinner-blue"></div>
            ) : error ? (
              <Message variant="danger">{error}</Message>
            ) : (
              <div className="">
                <h4 className="font-medium mb-2">
                  {job.title}
                  <Link
                    to={`/employer/job/edit/${job._id}`}
                    className="ml-1 font-normal apply-btn px-1">
                    Edit
                  </Link>
                  <button className="ml-1 vertical-middle">
                    <i class="far fa-trash-alt"></i>
                  </button>
                </h4>

                <div>
                  <p>{job.details}</p>
                  <p>
                    {job.file && job.file.length ? (
                      <div>
                        {" "}
                        <span className="font-weight-bolder">File:</span>{" "}
                        <a
                          target="_blank"
                          rel="noopener noreferrer"
                          href={job.file}>
                          document
                        </a>
                      </div>
                    ) : (
                      ""
                    )}
                  </p>
                  <p>
                    <span className="font-weight-bolder">Skills required:</span>{" "}
                    {job && job.skill && job.skill.join(", ")}
                  </p>
                  <p>
                    <span className="font-weight-bolder">Budget(USD):</span>{" "}
                    {job.budget}
                  </p>
                  <p>
                    <span className="font-weight-bolder">Status:</span>{" "}
                    {job.status}
                  </p>
                </div>
              </div>
            )}
          </div>
        </div>
      </RightDash>
    </div>
  );
};

export default EmployerJob;
